import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/service/api.service';
import * as _ from 'lodash';

const maxContent:number = 10;
const REST_SERVICE_URL = 'http://localhost:8080';
@Component({
  selector: 'app-admin-main',
  templateUrl: './admin-main.component.html',
  styleUrls: ['./admin-main.component.css']
})
export class AdminMainComponent implements OnInit {




  notices:Array<any> = [];

  pages:Array<any>=[];
  currentPage:number = 0;
  maxPage:number = 0;
  

  constructor(
    public apiService:ApiService,
  ) { }

  ngOnChanges():void{
  }
  ngOnInit(): void {
    this.apiService.getAllData()
      .then((resp:any) =>{
        this.notices = resp;

        this.maxPage  = Math.floor((this.notices.length-1)/10+1);

        this.pages = Array.from({length: this.maxPage},()=> { return {selected: false}} );
        this.pages[0].selected = true;
      })
      .catch((err)=>{
        console.log(err);
      })
  }

  nextPage(){
    if(this.currentPage<this.maxPage-1){
      this.pages[this.currentPage].selected=false;
      this.currentPage++;
      this.pages[this.currentPage].selected=true;
    }
  }
  prevPage(){
    if(this.currentPage > 0){
      this.pages[this.currentPage].selected=false;
      this.currentPage--;
      this.pages[this.currentPage].selected=true;
    }
  }

  selectNumber(page:any,pageNum:number){
    this.pages.map((page)=>page.selected=false);

    page.selected = true;
    this.currentPage = pageNum;
  }


  onClick(){
  

  }

}
